<template>
    <div>
        <!-- Modal Relatório -->
        <div class="modal fade" id="relatorioModalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Relatório</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="parms">
                        <relatorio :pparms="parms" :inmodal="true" />
                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Relatorio from './Relatorio.vue';
import $ from 'jquery';

export default {
    data() { 
        return { 
            parms: null, 
            relatorioId: null, 
        }
    }, 

    components: { 
        Relatorio, 
    }, 

    methods: { 
        abrir (parms) { 
            this.parms = null; 

            this.$nextTick(() => { 
                this.parms = parms; 
                $('#relatorioModalModal').modal('show');
            });           
        }
    }
} 
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>